// extracted by mini-css-extract-plugin
export default {"option":"_eb229a7b","icon":"_1f301633"};